module.exports = __webpack_public_path__ + "img/bg.4d227940.png";